import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  PageEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-pl-event-statment",
  templateUrl: "./pl-event-statment.component.html",
  styleUrls: ["./pl-event-statment.scss"],
})
export class PLEventStatmentComponent implements OnInit {
  selected: any = { startDate: 0, endDate: 0 };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  eventLevelList = new MatTableDataSource<any>();
  ProviderId: string = "";
  providers: any = [];
  sportId: string = "";
  competitionId: string = "";
  eventId: string = "";
  origin = [];
  category = "";
  subProvider = "";
  eventLevelListDisplayedSportColumns: string[] = [
    "event_name",
    "market_type",
    "bet_count",
    "profit_loss",
  ];
  startDate: any;
  endDate: any;
  userId: string;
  userName: string = "";
  OperatorId: string = "all";
  length: any = 0;
  page = 1;
  pageSize = 10;
  orgPageSize = 10;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.sportId = this.activatedRoute.snapshot.params.sportId;
    this.competitionId = this.activatedRoute.snapshot.params.competitionId;
    this.eventId = this.activatedRoute.snapshot.params.eventId;

    this.activatedRoute.queryParams.subscribe((params) => {
      this.OperatorId = params.operatorId;
      this.ProviderId = params["providerId"];
      this.userId = params["userId"];
      this.userName = params["userName"];
      this.startDate = params["startTime"];
      this.origin = params["origin"];
      this.category = params["category"];
      this.subProvider = params["subProvider"];
      this.endDate = params["endTime"];
      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };
    });

    this.providers = [
      { ProviderName: "Exchange", ProviderId: "Exchange" },
      { ProviderName: "SportsBook", ProviderId: "SportsBook" },
    ];
    if (this.ProviderId) {
      this.onSelectedProvider(this.ProviderId);
    } else {
      this.onSelectedProvider("Exchange");
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  // getOurProviders() {
  //   try {
  //     this.appService.getOurProviders().subscribe((res) => {
  //       if (res.status === "RS_OK") {
  //         this.providers = res.providers;
  //       } else {
  //         if (res.errorDescription === "Invalid Token!") {
  //           sessionStorage.clear();
  //           this.router.navigateByUrl("/login");
  //         }
  //       }
  //     });
  //   } catch (err) {}
  // }

  goToMarketLevel(data) {
    this.router.navigate(
      [
        `reports/pl-statment/${this.sportId}/${this.competitionId}/${this.eventId}/${data.marketId}`,
      ],
      {
        queryParams: {
          providerId: this.ProviderId,
          userId: this.userId ? this.userId : "",
          userName: this.userName ? this.userName : "",
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
          startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
          endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
        },
      }
    );
  }

  goBackToCompetitionPL = () => {
    this.router.navigate(
      [`reports/pl-statment/${this.sportId}/${this.competitionId}`],
      {
        queryParams: {
          providerId: this.ProviderId,
          sportId: this.sportId,
          userId: this.userId ? this.userId : "",
          userName: this.userName ? this.userName : "",
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
          startTime:
            this.selected.startDate !== null
              ? new Date(this.selected.startDate).getTime() / 1000
              : 0,
          endTime:
            this.selected.endDate !== null
              ? new Date(this.selected.endDate).getTime() / 1000
              : 0,
        },
      }
    );
  };

  goBackToSportPL = () => {
    this.router.navigate([`reports/pl-statment/${this.sportId}`], {
      queryParams: {
        providerId: this.ProviderId,
        userId: this.userId ? this.userId : "",
          userName: this.userName ? this.userName : "",
        operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
        sportId: this.sportId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        startTime:
          this.selected.startDate !== null
            ? new Date(this.selected.startDate).getTime() / 1000
            : 0,
        endTime:
          this.selected.endDate !== null
            ? new Date(this.selected.endDate).getTime() / 1000
            : 0,
      },
    });
  };

  goBackToUserPL = () => {
    this.router.navigate([`reports/pl-statment`]);
  };

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getReportData();
  }

  onSelectedProvider = (pid) => {
    this.ProviderId = pid;
    this.getReportData();
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  getReportData = () => {
    if (this.ProviderId !== "all") {
      try {
        let filters = {
          sportId: this.sportId,
          providerId: this.ProviderId,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          startTime:
            this.selected.startDate !== null
              ? new Date(this.selected.startDate).getTime() / 1000
              : 0,
          endTime:
            this.selected.endDate !== null
              ? new Date(this.selected.endDate).getTime() / 1000
              : 0,
          competitionId: this.competitionId,
          operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
          eventId: this.eventId,
          userId: this.userId ? this.userId : null,
          pageSize: this.orgPageSize,
          page: this.page,
        };
        this.appService.getEventPLData(filters).subscribe((res) => {
          if (res.status === "RS_OK") {
            if (res.sportPnLReport && res.sportPnLReport.length > 0) {
              res.sportPnLReport.sort(function (a, b) {
                return b.bet_count - a.bet_count;
              });

              // res.sportPnLReport.sort((a, b) => {
              //   if (a.market_type < b.market_type) {
              //     return -1;
              //   }
              //   if (a.market_type > b.market_type) {
              //     return 1;
              //   }
              //   return 0;
              // });
            }
            this.eventLevelList = new MatTableDataSource<any>(
              res.sportPnLReport
            );
            if (this.page == 1) {
              this.length = res.totalBets;
            } else {
              this.paginator.length = this.length;
            }
            // this.eventLevelList.paginator = this.paginator;
          }
        });
      } catch (err) {}
    }
  };
}
